import React, {useState} from 'react';
import moment from 'moment'

import { Style } from './Exports'

type Props = {
    messageObj: any
};

export const Message_TimerAdjust = (props: Props) => {

    const { messageObj } = props; 
    const [hover, setHover] = useState(false);    

  return (
    <div
    key={Math.random() * 1000}
    className="media"
    style={Style(hover)}
    onMouseEnter={() => setHover(true)}
    onMouseLeave={() => setHover(false)}
  >
    <div style={{ marginRight: "20px" }}>
      <h5>
        {messageObj.game_timestamp.m}:
        {messageObj.game_timestamp.s}
      </h5>
    </div>
    <i
      className="icon ion-ios-timer"
      style={{ color: "white" }}
    ></i>
    <div
      className="media-body"
      style={{ marginLeft: "10px" }}
    >
      <h5
        className="mg-b-0"
        style={{ fontWeight: "500", fontSize:'15px' }}
      >
       {messageObj.message}
      </h5>
      <small className="d-block text-muted">
        {moment(messageObj.timestamp).fromNow()}
      </small>
    </div>
  </div>
  );
};

